//Utils
import { withRouteWrapper } from "utils/routesUtils";

// import Dashboard from "pages/dashboard";
import Inicio from "pages/inicio";
import Profile from "pages/profile";
import SignIn from "pages/authentication/sign-in";
import SignUp from "pages/authentication/sign-up";
import SignOut from "pages/authentication/sign-out";
import Unauthorized from "pages/errorPages/Unauthorized";
import PermissionsManager from "pages/admin/manage-permissions/index";
import BandejaProcesos from "pages/procesos/bandeja";
import Procesos from "pages/procesos";
import ConsultarProcesos from "pages/procesos/components/consultarProcesos";
import Comunicaciones from "pages/procesos/comunicaciones";
import RegistrarProceso from "pages/procesos/registrar";
import ResumenProceso from "pages/procesos/resumen";
import AdmitirProceso from "pages/procesos/components/admitir";
import PlanesPago from "pages/planespago";
import Calendario from "pages/calendar/index";
// import RegistrarDeudas from "pages/procesos/registrar/deudas";
import UsuariosAdmin from "pages/admin/usuarios/index";
import SedesAdmin from "pages/admin/sedes/index";
import TarifasAdmin from "pages/admin/tarifas/index";
import ClientesAdmin from "pages/admin/clientes/index";
import AcreedoresAdmin from "pages/admin/acreedores/index";
import ApoderadosAdmin from "pages/admin/apoderados/index";
import Reportes from "pages/reportes";
import ParametrosConfiguracion from "pages/configuracion/parametros";
import SalasZoomConfiguracion from "pages/configuracion/salasZoom";

import RouteIcon from "common/Icons/RouteIcon";

// import Shop from "common/Icons/Shop";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import PersonAddIcon from "@mui/icons-material/PersonAdd";
import SettingsIcon from "@mui/icons-material/Settings";
import TuneIcon from "@mui/icons-material/Tune";
import VideocamIcon from "@mui/icons-material/Videocam";
import MeetingRoomIcon from "@mui/icons-material/MeetingRoom";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import PersonAddAltIcon from "@mui/icons-material/PersonAddAlt";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import ElectricalServicesIcon from "@mui/icons-material/ElectricalServices";
import LockPersonIcon from "@mui/icons-material/LockPerson";
import PeopleAltIcon from "@mui/icons-material/PeopleAlt";
import CustomerSupport from "common/Icons/CustomerSupport";
//import AddIcon from "@mui/icons-material/Add";
import PostAddIcon from "@mui/icons-material/PostAdd";
import FolderIcon from "@mui/icons-material/Folder";
import CurrencyExchangeIcon from "@mui/icons-material/CurrencyExchange";
//import PriceChangeOutlinedIcon from "@mui/icons-material/PriceChangeOutlined";
import FormatListBulletedIcon from "@mui/icons-material/FormatListBulleted";
import MailOutlineIcon from "@mui/icons-material/MailOutline";
import ContentPasteIcon from "@mui/icons-material/ContentPaste";
import ManageSearchIcon from "@mui/icons-material/ManageSearch";
import AssessmentIcon from "@mui/icons-material/Assessment";

export const RouteAccessType = {
  PUBLIC: "public",
  PROTECTED: "protected",
  ADMIN: "ADMIN",
  ALL_AUTH: "all_auth",
};

// Rutas ocultas que no aparecen en el sidebar pero están disponibles para navegación
export const hiddenRoutes = [
  {
    name: "Editar Proceso",
    key: "editar-proceso",
    route: "/procesos/editar/:identificador",
    breadcrumb: "Editar Proceso",
    component: withRouteWrapper(RegistrarProceso),
    access: RouteAccessType.PROTECTED,
  },
  {
    name: "Resumen Proceso",
    key: "resumen-proceso",
    route: "/procesos/resumen/:identificador",
    breadcrumb: "Resumen Proceso",
    component: withRouteWrapper(ResumenProceso),
    access: RouteAccessType.PROTECTED,
  },
  {
    name: "Admitir Proceso",
    key: "admitir-proceso",
    route: "/procesos/admitir/:identificador",
    breadcrumb: "Admitir Proceso",
    component: withRouteWrapper(AdmitirProceso),
    access: RouteAccessType.PROTECTED,
  },
];

const routes = [
  // {
  //   type: "collapse",
  //   name: "Inicio",
  //   key: "inicio",
  //   route: "/inicio",
  //   icon: (
  //     <RouteIcon>
  //       <Shop />
  //     </RouteIcon>
  //   ),
  //   component: Dashboard,
  //   noCollapse: true,
  //   access: RouteAccessType.ALL_AUTH,
  // },
  {
    type: "collapse",
    name: "Bienvenida",
    key: "Bienvenida",
    route: "/bienvenida",
    icon: (
      <RouteIcon>
        <AccountBalanceIcon />
      </RouteIcon>
    ),
    component: Inicio,
    noCollapse: true,
    access: RouteAccessType.ALL_AUTH,
  },
  {
    type: "title",
    title: "Módulo Operativo",
    key: "Operativo",
    access: RouteAccessType.PROTECTED,
  },
  {
    type: "none",
    name: "Calendario",
    key: "calendario",
    route: "/calendario",
    icon: (
      <RouteIcon>
        <CalendarMonthIcon />
      </RouteIcon>
    ),
    component: Calendario,
    noCollapse: true,
    access: RouteAccessType.ALL_AUTH,
  },
  {
    type: "nested",
    name: "Procesos",
    key: "procesos",
    icon: (
      <RouteIcon>
        <FolderIcon />
      </RouteIcon>
    ),
    children: [
      {
        name: "Registrar",
        key: "procesos-registrar",
        route: "/procesos/registrar",
        icon: (
          <RouteIcon>
            <PostAddIcon />
          </RouteIcon>
        ),
        component: RegistrarProceso,
        access: RouteAccessType.PROTECTED,
      },
      {
        name: "Bandeja",
        key: "bandeja",
        route: "/procesos/bandeja",
        icon: (
          <RouteIcon>
            <ContentPasteIcon />
          </RouteIcon>
        ),
        component: BandejaProcesos,
        access: RouteAccessType.PROTECTED,
      },
      {
        name: "Consultar",
        key: "consultar_rocesos",
        route: "/procesos/consultar_procesos",
        icon: (
          <RouteIcon>
            <ManageSearchIcon />
          </RouteIcon>
        ),
        component: ConsultarProcesos,
        access: RouteAccessType.PROTECTED,
      },
      {
        name: "Admin. Procesos",
        key: "procesos",
        route: "/procesos/consultar",
        icon: (
          <RouteIcon>
            <FormatListBulletedIcon />
          </RouteIcon>
        ),
        component: Procesos,
        access: RouteAccessType.PROTECTED,
      },
    ],
  },

  {
    type: "nested",
    name: "Comunicaciones",
    key: "comunicaciones",
    icon: (
      <RouteIcon>
        <FolderIcon />
      </RouteIcon>
    ),
    children: [
      {
        name: "Admin. Comunicaciones",
        key: "admin_comunicaciones",
        route: "/comunicaciones/consultar",
        icon: (
          <RouteIcon>
            <MailOutlineIcon />
          </RouteIcon>
        ),
        component: Comunicaciones,
        access: RouteAccessType.PROTECTED,
      },
    ],
  },
  {
    type: "title",
    title: "Módulo Cartera",
    key: "Cartera",
    access: RouteAccessType.PROTECTED,
  },
  {
    type: "nested",
    name: "Planes Pago",
    key: "planes_pago",
    icon: (
      <RouteIcon>
        <FolderIcon />
      </RouteIcon>
    ),
    children: [
      {
        name: "Admin. Planes Pago",
        key: "PlanesPago",
        route: "/planespago/consultar",
        icon: (
          <RouteIcon>
            <CurrencyExchangeIcon />
          </RouteIcon>
        ),
        component: PlanesPago,
        access: RouteAccessType.PROTECTED,
      },
    ],
  },
  {
    type: "collapse",
    name: "Reportes",
    key: "reportes",
    route: "/reportes",
    icon: (
      <RouteIcon>
        <AssessmentIcon />
      </RouteIcon>
    ),
    component: Reportes,
    noCollapse: true,
    access: RouteAccessType.PROTECTED,
    allowedRoles: ["ADMIN", "DIRECTOR", "COORDINADOR"],
  },
  {
    type: "none",
    name: "Perfil",
    key: "perfil",
    route: "/perfil",
    icon: (
      <RouteIcon>
        <CustomerSupport />
      </RouteIcon>
    ),
    component: Profile,
    noCollapse: true,
    access: RouteAccessType.ALL_AUTH,
  },
  {
    type: "none",
    name: "Sin Autorización",
    key: "unauthorized",
    route: "/sin-autorizacion",
    component: Unauthorized,
    access: RouteAccessType.PUBLIC,
  },
  {
    type: "none",
    name: "Sign In",
    key: "sign-in",
    route: "/authentication/sign-in",
    component: SignIn,
    noCollapse: true,
    access: RouteAccessType.PUBLIC,
  },
  {
    type: "none",
    name: "Logout",
    key: "sign-out",
    route: "/authentication/sign-out",
    component: SignOut,
    noCollapse: true,
    access: RouteAccessType.ALL_AUTH,
  },
  {
    type: "title",
    title: "Módulo Administrativo",
    key: "Configuraciones",
    access: RouteAccessType.ADMIN,
  },
  {
    type: "nested",
    name: "Admin. Datos",
    key: "administracion",
    icon: (
      <RouteIcon>
        <FolderIcon />
      </RouteIcon>
    ),
    children: [
      {
        name: "Acreedores",
        key: "acreedores",
        route: "/administracion/acreedores",
        icon: (
          <RouteIcon>
            <AccountBalanceIcon />
          </RouteIcon>
        ),
        component: AcreedoresAdmin,
        access: RouteAccessType.ADMIN,
      },
      {
        name: "Apoderados",
        key: "apoderados",
        route: "/administracion/apoderados",
        icon: (
          <RouteIcon>
            <ElectricalServicesIcon />
          </RouteIcon>
        ),
        component: ApoderadosAdmin,
        access: RouteAccessType.ADMIN,
      },
      {
        name: "Clientes",
        key: "clientes",
        route: "/administracion/clientes",
        icon: (
          <RouteIcon>
            <PersonAddAltIcon />
          </RouteIcon>
        ),
        component: ClientesAdmin,
        access: RouteAccessType.ADMIN,
      },
      {
        name: "Sedes",
        key: "sedes",
        route: "/administracion/sedes",
        icon: (
          <RouteIcon>
            <MeetingRoomIcon />
          </RouteIcon>
        ),
        component: SedesAdmin,
        access: RouteAccessType.ADMIN,
      },
      {
        name: "Tarifas",
        key: "tarifas",
        route: "/administracion/tarifas",
        icon: (
          <RouteIcon>
            <AttachMoneyIcon />
          </RouteIcon>
        ),
        component: TarifasAdmin,
        access: RouteAccessType.ADMIN,
      },
    ],
  },
  {
    type: "nested",
    name: "Admin. Usuarios",
    key: "usuarios",
    icon: (
      <RouteIcon>
        <FolderIcon />
      </RouteIcon>
    ),
    children: [
      {
        name: "Consultar",
        key: "Consultar_Usuarios",
        route: "/administracion/usuarios/consultar",
        icon: (
          <RouteIcon>
            <PeopleAltIcon />
          </RouteIcon>
        ),
        component: UsuariosAdmin,
        noCollapse: true,
        access: RouteAccessType.ADMIN,
      },
      {
        name: "Registrar Usuario",
        key: "registrar-usuario",
        route: "/administracion/usuarios/registrar",
        icon: (
          <RouteIcon>
            <PersonAddIcon />
          </RouteIcon>
        ),
        component: SignUp,
        noCollapse: true,
        access: RouteAccessType.ADMIN,
      },
      {
        name: "Gestionar Permisos",
        key: "permisos",
        route: "/administracion/usuarios/gestionar-permisos",
        icon: (
          <RouteIcon>
            <LockPersonIcon />
          </RouteIcon>
        ),
        component: PermissionsManager,
        access: RouteAccessType.ADMIN,
      },
    ],
  },
  // Módulo de Configuración: visible para ADMIN o para los roles con permiso en Gestionar Permisos
  {
    type: "title",
    title: "Configuración",
    key: "configuracion",
    access: RouteAccessType.PROTECTED,
    adminAccess: true,
  },
  {
    type: "nested",
    name: "Configuración",
    key: "configuracion-general",
    icon: (
      <RouteIcon>
        <SettingsIcon />
      </RouteIcon>
    ),
    children: [
      {
        name: "Parámetros Generales",
        key: "configuracion-parametros",
        route: "/configuracion/parametros",
        icon: (
          <RouteIcon>
            <TuneIcon />
          </RouteIcon>
        ),
        component: ParametrosConfiguracion,
        access: RouteAccessType.PROTECTED,
        adminAccess: true,
      },
      {
        name: "Salas Zoom",
        key: "configuracion-salas-zoom",
        route: "/configuracion/salas-zoom",
        icon: (
          <RouteIcon>
            <VideocamIcon />
          </RouteIcon>
        ),
        component: SalasZoomConfiguracion,
        access: RouteAccessType.PROTECTED,
        adminAccess: true,
      },
    ],
  },
];

export default routes;
